/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
// import { hoverTransition, aniSpeed } from '../../../utils/styles/general';



/* ++++++++++ --------------- LOADING - STATE : STYLES --------------- ++++++++++ */
export default {
	loadingstate: {
		position: 'absolute',
		top: '0',
		left: '0',
		width: '100%',
		height: '100%',
		display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
	}
}; 